/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
export const navigation = [
  {
    text: 'login',
    path: '/login',
    icon: 'home',
  },
  {
    text: 'Site & Equipment',
    path: '/siteequipment',
    icon: 'home',
  },
  {
    text: 'Users',
    path: '/userList',
    icon: 'user',
  },
  {
    text: 'Data Grid',
    path: '/display-data',
    icon: 'user',
  },
];
